var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.removeAllShow,
          expression: "removeAllShow"
        }
      ],
      staticClass: "popup"
    },
    [
      _c(
        "div",
        { staticClass: "content", attrs: { id: "twoStepverification" } },
        [
          _c("div", { staticClass: "title" }, [
            _vm.removeAll
              ? _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("language.twoStepverification.removeAll"))
                  )
                ])
              : _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("language.twoStepverification.removeMethod"))
                  )
                ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  return _vm.closePage()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "step-body-content" }, [
            _c(
              "div",
              {
                staticStyle: {
                  float: "left",
                  height: "60Px",
                  fontSize: "14Px",
                  textAlign: "center",
                  lineHeight: "20Px",
                  color: "#6f7886"
                }
              },
              [
                _vm.removeAll
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("language.twoStepverification.lostAccess")
                        )
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "language.twoStepverification.removeMethodSure"
                          )
                        )
                      )
                    ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "step-footer" }, [
              _c(
                "button",
                {
                  staticClass: "re-cancel",
                  on: {
                    click: function($event) {
                      return _vm.closePage()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.twoStepverification.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "re-bind",
                  on: {
                    click: function($event) {
                      return _vm.removeSubmit()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.leftBanner.remove")))]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-741523f1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-741523f1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/personal_center_popups/remove_all_devices_popop.vue
// module id = null
// module chunks = 